export * from './user';
export * from './home-details';
export * from './role';
export * from './general';
export * from './facility';
export * from './facility-configuration';
export * from './group';
export * from './reading';
export * from './reports';






// WEBPACK FOOTER //
// ./src/app/shared/models/index.ts